// Screen breakpoint widths
window.XS_WIDTH = 0;
window.SM_WIDTH = 768;
window.MD_WIDTH = 992;
window.LG_WIDTH = 1200;
window.XL_WIDTH = 1600;
window.UW_WIDTH = 2000;
// Video size breakpoint
window.VIDEO_MD_WIDTH = 750;
